<template>
  <div v-if="$store.state.global.stickers" id="stickersTab">
    <b-row>
      <b-col>
        <b-form-group>
          <search-input v-model="query" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-col class="text-right">
          <b-button v-router-link="{ name: 'sticker-editor', query: { category_id: $store.state.global.category.id }}" variant="outline-primary">
            <i class="fa fa-plus-circle" /> Add Sticker
          </b-button>
        </b-col>
      </b-col>
    </b-row>

    <b-card-group columns>
      <b-card no-body
        v-for="sticker in displayStickers"
        :key="sticker.id"
        v-router-link="{ name:'sticker-detail', params: sticker}"
        
      >
        <img :src="'https://cdn.gokaizen.com/' + sticker.src" alt="" style="max-width:100%;">
        <b-card-body>
          <h3>{{ sticker.name }}</h3>
        </b-card-body>
      </b-card>
    </b-card-group>
    <div v-if="displayStickers.length == 0" class="text-center">
      No results
    </div>
  </div>
</template>

<script>
import $search from '@/services/search';
import SearchInput from '@/components/SearchInput';

export default {
  name: 'MediacategoryStickersTab',

  components: {
    SearchInput,
  },

  data() {
    return {
      query: '',
    };
  },

  computed: {
    displayStickers() {
      return $search(this.$store.state.global.stickers, this.query);
    },
  },
};
</script>
